import React from 'react';
import { Link } from 'react-router-dom';

export function AuthPolicyBlock() {
  return (
    <div className="auth-policy">
      <p>
        Your name, company name, and email will not be disclosed to anyone, including
        internal teams or third parties.
      </p>
      <p>
        <Link to="/privacy_policy" className="auth-link">
          Privacy Policy
        </Link>{' '}
        and{' '}
        <Link to="/terms_condition" className="auth-link">
          Terms &amp; Conditions
        </Link>
        .
      </p>
    </div>
  );
}

export default AuthPolicyBlock;
